export default "__VITE_ASSET__C9$aSFCX__"